import moment from "moment";

export const timeFormat = (isoDate: string) => {
  return moment(isoDate).subtract(new Date().getTimezoneOffset() / 60, "hours");
};
